import * as React from 'react';
import { Box, Button, FormControl, FormLabel, Grid, Input, Link, Modal, ModalDialog, Sheet, Stack, Table, Typography } from "@mui/joy";
import { useDispatch, useSelector } from "react-redux";
import { cleanForm, cleanFormEncrypted, setFormAttribute, setModalOpen, setSelectedBucket, triggerCarregaBuckets, triggerEnviaForm, triggerRemoveFile, triggerSelectBucket, updateAttributeFormEncrypted } from "./StorageSlice";
import { formatDateComHoras } from '../helper/functions';
import { server_url } from '../core/config_geral';
import { DeleteSharp } from '@mui/icons-material';

function Storage() {
    var storage = useSelector((state) => state.storage)
    var buckets = storage.buckets
    var arquivos = storage.arquivos
    var open = storage.modalOpen
    var showModalEncrypted = storage.formDownloadEncrypted.url != false
    var token = useSelector((state) => state.auth.token)
    var dispatch = useDispatch()

    var setOpen = () => {
        dispatch(cleanForm())
        dispatch(setFormAttribute({
            campo: "remetente",
            valor: "anano.front.manager"
        }))
        dispatch(setFormAttribute({
            campo: "bucket",
            valor: storage.selectedBucket == null ?
                "anano.manager.geral" :
                storage.selectedBucket
        }))
        dispatch(setModalOpen(!open))
    }

    var carregaBuckets = () => {
        dispatch(triggerCarregaBuckets())
    }

    React.useEffect(() => {
        carregaBuckets()
    }, []);

    return <Grid container sx={{ p: "10px" }}>
        <Stack spacing={2}>
            <Box>
                Adicionar <Button onClick={setOpen}>+</Button>
            </Box>
            {storage.selectedBucket && <Box>
                <b>Selected Bucket:</b> {storage.selectedBucket} <Link
                    onClick={() => dispatch(setSelectedBucket(null))}>[trocar]</Link>
            </Box>}
            <Sheet>
                {!storage.selectedBucket && <ListaBuckets buckets={buckets} />}
                {storage.selectedBucket && <ListaArquivos arquivos={arquivos} token={token} />}
            </Sheet>
        </Stack>
        <ModalUpload setOpen={setOpen} />
        <ModalDowloadEncrypted open={showModalEncrypted} />
    </Grid>
}

function ModalDowloadEncrypted(props) {

    var dispatch = useDispatch();
    var form = useSelector((state) => state.storage.formDownloadEncrypted)
    var open = props.open

    return <Modal open={open} onClose={() => {
        dispatch(cleanFormEncrypted())
    }}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ maxWidth: 500 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2">
                Arquivo exige senha para descriptografar
            </Typography>
            <Typography id="basic-modal-dialog-description" textColor="text.tertiary">
                {form.erro}
            </Typography>
            <Stack spacing={2}>
                <FormControl>
                    <FormLabel>Senha</FormLabel>
                    <Input onChange={(e) => dispatch(
                        updateAttributeFormEncrypted({
                            campo: "password",
                            value: e.target.value
                        })
                    )} required value={form.password} />
                </FormControl>
                <Box style={{overFlow: "none"}}>
                    <Link href={form.url+"&encrypt_key="+form.password}
                    target="_blank">link&encrypt_key={form.password}</Link>
                </Box>
            </Stack>
        </ModalDialog>
    </Modal>
}

function ModalUpload(props) {

    var dispatch = useDispatch();
    var storage = useSelector((state) => state.storage)

    var setOpen = props.setOpen
    var uploading = storage.uploading
    var form = storage.form
    var open = storage.modalOpen
    var updateAttribute = (att, value) => {

        dispatch(setFormAttribute({
            campo: att,
            valor: value
        }))
    }

    return <Modal open={open} onClose={setOpen}>
        <ModalDialog
            aria-labelledby="basic-modal-dialog-title"
            aria-describedby="basic-modal-dialog-description"
            sx={{ maxWidth: 500 }}
        >
            <Typography id="basic-modal-dialog-title" component="h2">
                Novo Arquivo
            </Typography>
            <Typography id="basic-modal-dialog-description" textColor="text.tertiary">
                {form.erro}
            </Typography>
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                    setOpen(false);
                }}
            >
                <Stack spacing={2}>
                    <FormControl>
                        <FormLabel>Bucket</FormLabel>
                        <Input onChange={(e) => updateAttribute("bucket", e.target.value)} required value={form.bucket} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Path</FormLabel>
                        <Input onChange={(e) => updateAttribute("path", e.target.value)} autoFocus value={form.path} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Remetente</FormLabel>
                        <Input value={form.remetente} onChange={(e) => updateAttribute("remetente", e.target.value)} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Crypt Key</FormLabel>
                        <Input value={form.encryptKey} onChange={(e) => updateAttribute("encryptKey", e.target.value)} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>Arquivo</FormLabel>
                        <Input name="file" type="file" onChange={(e) => updateAttribute("file", e.target.files[0])} />
                    </FormControl>
                    <Button onClick={() => dispatch(triggerEnviaForm())} disabled={uploading}>{uploading ? "Enviando..." : "Submit"}</Button>
                </Stack>
            </form>
        </ModalDialog>
    </Modal>
}

function ListaArquivos(props) {
    var arquivos = props.arquivos
    var dispatch = useDispatch()
    var deletar = (bucket, id) => {
        dispatch(triggerRemoveFile({ bucket, id }))
    }
    return <Table size="small" aria-label="striped table" stripe={"odd"}>
        <thead>
            <tr>
                <th style={{ width: "54%" }}>Nome</th>
                <th style={{ textAlign: "left", width: "10%" }}>Size</th>
                <th style={{ textAlign: "left", width: "13%" }}>Data Cadastro</th>
                <th style={{ textAlign: "left", width: "13%" }}>Data Alteração</th>
                <th style={{ textAlign: "center", width: "5%" }}>X</th>
                <th style={{ textAlign: "center", width: "5%" }}>V</th>
            </tr>
        </thead>
        <tbody>
            {arquivos.map((row) => {
                return <tr key={row.id}>
                    <td style={{ padding: "2px 10px" }}>
                        <LinkArquivo arquivo={row} token={props.token} />
                    </td>
                    <td style={{ padding: "2px 0px" }}>
                        {row.sizeNatural} {row.encrypted && <span style={{ color: "#c20000" }}>[E]</span>}
                    </td>
                    <td style={{ padding: "2px 0px" }}>
                        {formatDateComHoras(new Date(row.dataCadastro))}
                    </td>
                    <td style={{ padding: "2px 0px" }}>
                        {formatDateComHoras(new Date(row.dataUltimaAlteracao))}
                    </td>
                    <td style={{ padding: "2px 0px", textAlign: "center" }}>
                        <Link onClick={() => { deletar(row.bucket, row.id) }}>[x]</Link>
                    </td>
                    <td style={{ padding: "2px 0px", textAlign: "center" }}>
                        <Link onClick={() => {
                            navigator.clipboard.writeText(row.id)
                        }}>{row.version}</Link>
                    </td>
                </tr>
            })}
        </tbody>
    </Table>
}

function LinkArquivo(props) {
    var row = props.arquivo
    var dispatch = useDispatch()
    var token = props.token

    var path = server_url + "/storage/dw/buckets/" + row.bucket + "/arquivos/" + row.id + "/download?access_token=" + token

    if (row.encrypted) {
        return <Link onClick={() => { 
            dispatch(updateAttributeFormEncrypted({
                campo : "url",
                value : path
            }))
        }}> {row.pathCompletoSemBucket} </Link>
    }

    return <Link href={path} target='_blank'> {row.pathCompletoSemBucket} </Link>
}

function ListaBuckets(props) {
    var buckets = props.buckets
    var dispatch = useDispatch()
    return <Table size="small" aria-label="striped table" stripe={"odd"}>
        <thead>
            <tr>
                <th style={{ width: '40%', padding: "10px" }}>Nome</th>
            </tr>
        </thead>
        <tbody>
            {buckets.map((row) => (
                <tr key={row}>
                    <td style={{ padding: "2px 10px" }}>
                        <Link onClick={() => dispatch(triggerSelectBucket(row))}>{row}</Link>
                    </td>
                </tr>
            ))}
        </tbody>
    </Table>
}

export default Storage;